



































import { Vue, servicesURL } from "../../constants/constants";
import { staticContent } from "../../localisation/detect-lang";

export default Vue.component("confirmation-modal", {
  props: {
    message: "",
    yesBtn: "",
    noBtn: ""
  },
  data() {
    return {
      servicesURL,
      staticContent,
    };
  },
  computed: {
    bindConditionalClasses() {
      return this.$root.bindConditionalClasses;
    },
  },
  methods: {
    closeModal() {
      this.$emit('close')
    },
    handleFn() {
      this.$emit('confirm')
    }
  },
});
